/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/order-tasks';

export const OrderTaskApi = {
  updateMulti: async (body: any) => {
    const url = `${pathname}/multi`;
    try {
      const response = await entityService.patch(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateMultiPurchaseOrder: async (body: any) => {
    const url = `${pathname}/multi-purchase-order`;
    try {
      const response = await entityService.patch(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
